module.exports = __webpack_public_path__ + "static/media/4.f8e3ea9d.pdf";